import { Component, Input } from '@angular/core';

@Component({
  selector: 'conditions-list',
  template: require('./conditions-list.component.pug'),
  styles: [require('./conditions-list.component.css').toString()],
})
export class ConditionsListComponent {
  @Input()
  conditions: any[];
  @Input()
  deleteVisible: boolean;

  @Input()
  onConditionDelete: (condition: any) => void;
}
